import { Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import FiberCompanySelector from "./../../../../../components/FiberCompanySelector";
const Index = ({ open, setOpen,setBoltMode,companies,setCompanies }) => {



	return (
		<Modal open={open} onClose={() => setOpen(false)}>
			<div className="custom_modal" style={{ overflow: "unset" }}>
				<h2 className="text-2xl font-bold">Bolt Mode</h2>
				<div className="w-full">
					<FiberCompanySelector
						placeholder="Select Fiber Company"
						setUser={setCompanies}
						multiple={true}
					/>
				</div>
				<div className="grid grid-cols-2 gap-4">
					<button
						onClick={() => {
                            setBoltMode(true);
							setOpen(false);
							// Handle the action for Bolt Mode here
							console.log("Selected Companies:", companies);
						}}
						className="btn btn-primary"
					>
						Activate Bolt Mode
					</button>
                    <button
                        onClick={() => setOpen(false)}
                        style={{
                            backgroundColor: "#f0f0f0",
                            color: "#333",
                            border: "1px solid #ccc"
                        }}
                        className="btn btn-secondary ml-2"
                    >
                        Cancel
                    </button>

				</div>
			</div>
		</Modal>
	);
};

export default Index;
